<script setup lang="ts">
import { FairIcon } from '@/ui/primitives/FairIcon'
import type { FairIconName } from '@/ui/tokens/icons.data'

/**
 * Tag — DS "Controls" › Tag (199:18303).
 * Style=Positive · Negative · Neutral · AI, optional leading / trailing 16px icons.
 */
interface FairTagProps {
  label: string
  tone?: 'positive' | 'negative' | 'neutral' | 'ai'
  leadingIcon?: FairIconName
  trailingIcon?: FairIconName
}

withDefaults(defineProps<FairTagProps>(), {
  tone: 'neutral',
  leadingIcon: undefined,
  trailingIcon: undefined,
})
</script>

<template>
  <span class="fair-tag" :class="`fair-tag--${tone}`">
    <FairIcon v-if="leadingIcon" :name="leadingIcon" :size="16" class="fair-tag__icon" />
    <span class="fair-tag__label">{{ label }}</span>
    <FairIcon v-if="trailingIcon" :name="trailingIcon" :size="16" class="fair-tag__icon" />
  </span>
</template>
